export default {
  'login.username': 'Tài khoản',
  'login.password': 'Mật khẩu',
  'login.username_required': 'Vui lòng nhập tài khoản!',
  'login.password_required': 'Vui lòng nhập mật khẩu!',
  'pages.login.rememberMe': 'Ghi nhớ đăng nhập',
  'pages.account.logout': 'Đăng xuất',
  'pages.new.name': 'Tiêu đề',
  'pages.new.image': 'Hình ảnh',
  'pages.new.url': 'Đường dẫn',
  'pages.action': 'Hành động',
  'pages.type': 'Loại',
  'pages.status': 'Trạng thái',
  'common.confirm_delete': 'Xác nhận xóa',
  'common.content_delete': 'Bạn có chắc chắn muốn xóa?',
  'common.confirm': 'Xác nhận',
  'common.cancel': 'Hủy',
  'news.url_placeholder': 'Đường dẫn: https://...',
  'news.description': 'Mô tả',
  'news.content': 'Nội dung',
  'common.save': 'Lưu',
  'common.delete_success': 'Xoá dữ liệu thành công',
  'common.create_success': 'Tạo mới thành công',
  'common.update_success': 'Cập nhật thành công',
  'pages.quote.author': 'Tác giả',
  'pages.celebrity.name': 'Tên',
  'pages.zodiac.select': 'Chọn cung hoàng đạo',
  'pages.numerology.select': 'Chọn thần số học',
  'pages.iap.platform': 'Nền tảng',
  'pages.iap.price': 'Giá',
  'pages.iap.status': 'Trạng thái',
  'pages.iap.product_type': 'Loại sản phẩm',
  'pages.iap.currency': 'Loại tiền tệ',
  'pages.iap.package_id': 'ID gói',
  'pages.zodiac.from_date': 'Ngày bắt đầu',
  'pages.zodiac.name': 'Cung hoàng đạo',
  'pages.zodiac.image': 'Hình ảnh',
  'pages.celebrity.zodiac': 'Cung hoàng đạo',
  'pages.numerology.relation.target_numerology': 'Thần số học 1',
  'pages.numerology.relation.destination_numerology': 'Thần số học 2',
  'pages.receipt.product.price': 'Thanh toán',
  'pages.receipt.receipt_creation_date': 'Ngày thực hiện',
  'pages.receipt.user.name': 'Người giao dịch',
  'pages.receipt.product.title': 'Tên gói',
  'pages.user.name': 'Tên người dùng',
  'pages.user.email': 'Email',
  'pages.user.account_type': 'Tài khoản',
  'pages.user.provider': 'Nền tảng',
  'pages.user.birthday': 'Sinh nhật',
  'pages.noti.title': 'Tiêu đề',
  'pages.noti.date': 'Ngày gửi thông báo',
  'pages.notification.push_type': 'Thông báo tới',
  'pages.noti.category_type': 'Sự kiện',
  'pages.tarot.topic.name': 'Chủ đề',
  'pages.tarot.topic.question': 'Câu hỏi',
  'pages.notification.title': 'Tiêu đề',
  'pages.notification.body': 'Nội dung',
  'pages.notification.users': 'Người dùng',
  'pages.notification.schedule_time': 'Hẹn giờ',
  'pages.notification.topic': 'Chủ đề',
  'pages.tarot.tarot_card': 'Thẻ Tarot',
  'page.zodiac.horoscopes': 'Mối quan hệ',
  'pages.tarot.topic': 'Chủ đề',
  'pages.tarot.question': 'Câu hỏi',
  'pages.banner.type': 'Trạng thái',
  'pages.banner.select': 'Chọn loại hiển thị',
  'common.time': 'Thời gian',
  'common.type': 'Giai đoạn',
  'common.weekly': 'Hàng tuần',
  'common.monthly': 'Hàng tháng',
  'common.yearly': 'Hàng năm',
  'common.daily': 'Hàng ngày',
  'common.from_date': 'Từ ngày',
  'common.to_date': 'Đến ngày',
  'resignation.staff': 'Nhân viên',
  'common.department': 'Bộ phận',
  'common.admin_group': 'Nhóm quản trị',
  'common.emptyText': 'Không có dữ liệu',
  'common.search_member': 'Tìm kiếm thành viên',
  'permission_name.dashboard_metric': 'Thống kê bảng điều khiển',

  'common.delete_title': 'Xác nhận xóa',
  'common.okText': 'Xác nhận',
  'common.cancelText': 'Hủy',

  'common.permission': 'Quyền quản trị',
  'common.edit': 'Chỉnh sửa',
  'common.delete': 'Xóa',
  'permission_name.dashboard_player_metric': 'Player metrics',
  'permission_name.dashboard_monetization_metric': 'Monetization metrics',
  'permission_name.dashboard_acquisition_metric': 'Acquisition metrics',
  'permission_name.customer_profile': 'Thông tin cơ bản',
  'permission_name.customer_game': 'Game đã chơi',
  'permission_name.customer_payment': 'Nạp',
  'permission_name.customer_note': 'Ghi chú',
  'permission_name.customer_ticket': 'Ticket',
  'permission_name.article_post': 'Bài viết',
  'permission_name.article_video': 'Video',
  permission_name: {
    data_news: 'Tin tức',
    data_music: 'Âm nhạc',
    data_quote: 'Trích dẫn',
    data_zodiac: 'Cung hoàng đạo',
    data_numerology: 'Thần số học',
    data_prayer: 'Văn khấn',
    data_tarot: 'Tarot',
    biz_user: 'Người dùng',
    biz_iap_package: 'Gói IAP',
    biz_iap_receipt: 'Biên lai IAP',
    system_admin: 'Quản trị viên hệ thống',
    system_permission: 'Phân quyền hệ thống',
  },
  'permission.option': {
    can_create_and_update: 'Thêm/Sửa',
  },
  'scope_name.dashboard': 'Dashboard',
  'scope_name.data': 'Dữ liệu',
  'scope_name.biz': 'Kinh doanh',
  'scope_name.system': 'Hệ thống',
  'permission.option.can_update': 'Thêm/Sửa',
  'permission.option.can_delete': 'Xoá',
  'permission.option.can_view': 'Xem',
  'common.title_permission': 'Phân quyền chức danh : ',
  'common.view_member_list': 'Xem danh sách thành viên',
  'common.edit_permission': 'Chỉnh sửa phân quyền',
  'common.all_permission': 'Tất cả các quyền',
  'permission.require': 'Bắt buộc phải chọn cài đặt 1 phân quyền',
  'common.processing': 'Đang thực hiện',
  'permission.create.success': 'Tạo mới quyền quản trị thành công!',
  'permission.update.success': 'Chỉnh sửa quyền quản trị thành công!',
  'common.role_name': 'Tên quyền quản trị',
  'common.role_name_required': 'Tên quyền quản trị không được để trống',
  'common.description': 'Mô tả',
  'common.permission.label': 'Quyền',
  'administrator.update.success': 'Cập nhật thông tin quản trị viên thành công!',
  'administrator.create': 'Tạo mới quản trị viên',
  'profile.update.success': 'Cập nhật thông tin tài khoản thành công!',
  'common.admin_name': 'Tên quản trị viên',
  'common.admin_name_required': 'Tên quản trị viên không được để trống',
  'common.admin_username': 'Tên đăng nhập',
  'common.admin_username_required': 'Tên đăng nhập không được để trống',
  'common.admin_password': 'Mật khẩu',
  'common.admin_password_required': 'Mật khẩu không được để trống',
  'common.admin_repassword': 'Nhập lại mật khẩu',
  'common.admin_repassword_required': 'Vui lòng nhập lại mật khẩu',
  'common.admin_repassword_not_match': 'Mật khẩu nhập lại không khớp',
  'administrator.create.success': 'Tạo mới quản trị viên thành công!',
  'administrator.change_password.success': 'Đổi mật khẩu quản trị viên thành công!',
  'permission.update.group.success': 'Cập nhật nhóm quyền quản trị thành công!',
  'pages.notAuthorized': 'Xin lỗi, bạn không có quyền truy cập trang này.',
  'pages.backHome': 'Trở về trang chủ',
  'pages.goBack': 'Quay lại trang trước',
  'permission.select.member': 'Chọn thành viên',
  'pages.view_count': 'Lượt xem',
  'pages.click_count': 'Lượt nhấp',
  'pages.account.change_password': 'Đổi mật khẩu',
};
